import $store from '../store';
// eslint-disable-next-line import/no-cycle
import HttpClient from './http';

export const fetchCurrentUser = async () => {
  try {
    const user = $store.getters['user/getUser'];
    const resp = await HttpClient.get('profile');
    if (!resp || !resp.data) {
      return {
        success: false,
      };
    }
    $store.dispatch('user/setUser', { ...user, ...resp.data });
    return {
      success: true,
      user: { ...user, ...resp.data },
    };
  } catch (error) {
    return {
      success: false,
    };
  }
};

export const getUsers = async (data) => {
  try {
    const resp = await HttpClient.get('users', {
      params: data,
    });

    if (!resp || !resp.data) {
      return {
        success: false,
      };
    }
    return {
      success: true,
      data: resp.data,
    };
  } catch (error) {
    return {
      success: false,
    };
  }
};

export const getTeachingCoordinatorsAndAdmins = async () => {
  try {
    const resp = await HttpClient.get('users/teaching-coordinators-and-admins');

    if (!resp || !resp.data) {
      return {
        success: false,
      };
    }
    return {
      success: true,
      data: resp.data,
    };
  } catch (error) {
    return {
      success: false,
    };
  }
};

export const newUser = async (data) => {
  try {
    const resp = await HttpClient.post('auth/register', data);
    if (!resp || !resp.data) {
      return {
        success: false,
      };
    }
    return {
      success: true,
      data: resp.data,
    };
  } catch (error) {
    const {
      data: { message, error: errorMsg },
    } = error.response;
    return {
      success: false,
      message: message || errorMsg,
    };
  }
};

export const deleteUserById = async (data) => {
  try {
    const resp = await HttpClient.delete('users/admin/delete', {
      params: data,
    });
    if (!resp || !resp.data) {
      return {
        success: false,
      };
    }
    return {
      success: true,
      data: resp.data,
    };
  } catch (error) {
    return {
      success: false,
      message: error.message || error.error,
    };
  }
};

export const updateUserAdmin = async (data) => {
  try {
    const resp = await HttpClient.put('users/admin/update', data);
    if (!resp || !resp.data) {
      return {
        success: false,
      };
    }
    return {
      success: true,
      data: resp.data,
    };
  } catch (error) {
    const {
      data: { message, error: errorMsg },
    } = error.response;
    return {
      success: false,
      message: message || errorMsg,
    };
  }
};

// Update do próprio usuário
export const updateUser = async (data) => {
  try {
    const resp = await HttpClient.put('users/update', data);
    if (!resp || !resp.data) {
      return {
        success: false,
      };
    }
    return {
      success: true,
      data: resp.data,
    };
  } catch (error) {
    const {
      data: { message, error: errorMsg },
    } = error.response;
    return {
      success: false,
      message: message || errorMsg,
    };
  }
};

export const generateNewPasswordUser = async (data) => {
  try {
    const resp = await HttpClient.put('auth/new-password', data);
    if (!resp || !resp.data) {
      return {
        success: false,
      };
    }
    return {
      success: true,
      data: resp.data,
    };
  } catch (error) {
    return {
      success: false,
    };
  }
};

export const updateNewPasswordUser = async (data) => {
  try {
    const resp = await HttpClient.put('auth/update-password', data);
    if (!resp || !resp.data) {
      return {
        success: false,
      };
    }
    return {
      success: true,
      data: resp.data,
    };
  } catch (error) {
    return {
      success: false,
    };
  }
};

export const updateLgpdApprove = async (data) => {
  try {
    const resp = await HttpClient.put('users/update-lgpd-approve', data);
    if (!resp || !resp.data) {
      return {
        success: false,
      };
    }
    return {
      success: true,
      data: resp.data,
    };
  } catch (error) {
    const {
      data: { message, error: errorMsg },
    } = error.response;
    return {
      success: false,
      message: message || errorMsg,
    };
  }
};

export const deleteUserLgpd = async () => {
  try {
    const resp = await HttpClient.delete('users/delete');
    if (!resp || !resp.data) {
      return {
        success: false,
      };
    }
    return {
      success: true,
      data: resp.data,
    };
  } catch (error) {
    return {
      success: false,
    };
  }
};
